/**
 * WT - Sdusa Office Cro Dynamic Script
 * Performance, Accessibility & Conversion Optimized
 */
(function () {
  'use strict';

  function initSection(root) {
    if (!root || root.dataset.init === '1') return;
    root.dataset.init = '1';

    var hero = root.dataset.hero || '';

    // Gallery & Thumbnails handling
    var art = root.querySelector('.sdusacro-art');
    var tabs = root.querySelector('.sdusacro-tabs');
    var gallery = (root.dataset.gallery || '')
      .split('||')
      .map(function (x) { return x.trim(); })
      .filter(Boolean);
    var title = root.dataset.title || 'Product artwork';

    if (art && tabs) {
      if (gallery.length > 0) {
        var showGalleryImage = function (index) {
          if (!gallery[index]) return;
          var mainImg = art.querySelector('img');
          if (mainImg) {
            mainImg.src = gallery[index];
            mainImg.srcset = '';
          } else {
            art.innerHTML = '<img src="' + gallery[index] + '" alt="' + title.replace(/"/g, '&quot;') + '" width="600" height="600" loading="eager" fetchpriority="high">';
          }
          tabs.querySelectorAll('button').forEach(function (btn, bi) {
            var isActive = bi === index;
            btn.classList.toggle('active', isActive);
            btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
          });
        };

        // If tabs are empty for some reason, populate them; otherwise keep server-rendered markup
        if (tabs.children.length === 0) {
          tabs.innerHTML = gallery.map(function (url, i) {
            return '<button type="button" data-i="' + i + '"' + (i === 0 ? ' class="active" aria-selected="true"' : ' aria-selected="false"') + ' aria-label="View product image ' + (i + 1) + '">' +
              '<img src="' + url + '" alt="" width="36" height="36" loading="lazy">' +
              '</button>';
          }).join('');
        }

        tabs.addEventListener('click', function (e) {
          var btn = e.target.closest('button');
          if (btn && btn.dataset.i !== undefined) {
            showGalleryImage(parseInt(btn.dataset.i, 10));
          }
        });

        tabs.addEventListener('keydown', function (e) {
          var activeBtn = tabs.querySelector('button.active');
          if (!activeBtn) return;
          var curIndex = parseInt(activeBtn.dataset.i || '0', 10);
          var allBtns = tabs.querySelectorAll('button');
          if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
            e.preventDefault();
            var nextIndex = (curIndex + 1) % allBtns.length;
            showGalleryImage(nextIndex);
            allBtns[nextIndex].focus();
          } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
            e.preventDefault();
            var prevIndex = (curIndex - 1 + allBtns.length) % allBtns.length;
            showGalleryImage(prevIndex);
            allBtns[prevIndex].focus();
          }
        });

        // Initialize first image if not already rendered
        if (!art.querySelector('img') && gallery[0]) {
          showGalleryImage(0);
        }
      } else if (hero) {
        art.innerHTML = '<img src="' + hero + '" alt="' + title.replace(/"/g, '&quot;') + '" width="600" height="600" loading="eager">';
      }
    }

    // Interactive Smooth Hover Zoom (Follow Mouse Position) & Click-to-Zoom Modal
    if (art) {
      var zoomRaf = null;
      art.addEventListener('mousemove', function (e) {
        var img = art.querySelector('img');
        if (!img) return;

        if (zoomRaf) cancelAnimationFrame(zoomRaf);
        zoomRaf = requestAnimationFrame(function () {
          var rect = art.getBoundingClientRect();
          var x = e.clientX - rect.left;
          var y = e.clientY - rect.top;

          var xPercent = Math.max(0, Math.min(100, (x / rect.width) * 100));
          var yPercent = Math.max(0, Math.min(100, (y / rect.height) * 100));

          img.style.transformOrigin = xPercent + '% ' + yPercent + '%';
          img.style.transform = 'scale(1.35)';
        });
      });

      art.addEventListener('mouseleave', function () {
        var img = art.querySelector('img');
        if (!img) return;
        if (zoomRaf) cancelAnimationFrame(zoomRaf);
        img.style.transform = 'scale(1)';
      });

      // Accessible Click-to-Zoom Modal
      art.addEventListener('click', function (e) {
        var img = e.target.closest('img');
        if (!img) return;

        var zoomModal = document.createElement('div');
        zoomModal.className = 'sdusacro-zoom';
        zoomModal.setAttribute('role', 'dialog');
        zoomModal.setAttribute('aria-modal', 'true');
        zoomModal.setAttribute('aria-label', 'Image preview');

        var zoomImg = document.createElement('img');
        zoomImg.src = img.src;
        zoomImg.alt = img.alt || 'Zoomed product preview';
        zoomModal.appendChild(zoomImg);

        var closeModal = function () {
          window.removeEventListener('keydown', onKeyDown);
          zoomModal.remove();
        };

        var onKeyDown = function (evt) {
          if (evt.key === 'Escape') closeModal();
        };

        zoomModal.addEventListener('click', closeModal);
        window.addEventListener('keydown', onKeyDown);
        document.body.appendChild(zoomModal);
      });
    }

    // Transform raw FAQ metafield HTML (with h5.heading-font, h3 headings, .faq-item, etc.) into proper details/summary accordions
    var faqContainers = root.querySelectorAll('.sdusacro-faq-list');
    faqContainers.forEach(function (faqContainer) {
      // If it already uses details/summary, no need to transform
      if (faqContainer.querySelector('details')) return;

      var faqItems = [];

      // Check if structured with .faq-item containers
      var faqItemEls = faqContainer.querySelectorAll('.faq-item');
      if (faqItemEls.length > 0) {
        faqItemEls.forEach(function (itemEl) {
          // Find the question elements inside this item
          var qEl = itemEl.querySelector('h5, h4, h6, .heading-font');
          if (qEl) {
            // There might be multiple questions in a single .faq-item separated by <br> or multiple h5s
            var allQs = itemEl.querySelectorAll('h5, h4, h6');
            if (allQs.length > 1) {
              allQs.forEach(function (q) {
                var qText = (q.textContent || '').trim();
                if (!qText) return;
                var ansNodes = [];
                var n = q.nextSibling;
                while (n) {
                  if (n.nodeType === 1 && (n.matches('h5, h4, h6') || n.querySelector('h5, h4, h6'))) break;
                  ansNodes.push(n);
                  n = n.nextSibling;
                }
                var tempDiv = document.createElement('div');
                ansNodes.forEach(function (node) { tempDiv.appendChild(node.cloneNode(true)); });
                var cleanedHtml = tempDiv.innerHTML.trim().replace(/^(?:<br\s*\/?>|\s)+|(?:<br\s*\/?>|\s)+$/gi, '');
                if (cleanedHtml) {
                  faqItems.push({ question: qText, answerHtml: cleanedHtml });
                }
              });
            } else {
              var qText = (qEl.textContent || '').trim();
              var clone = itemEl.cloneNode(true);
              var qInClone = clone.querySelector('h5, h4, h6, .heading-font');
              if (qInClone) qInClone.remove();
              var cleanedHtml = clone.innerHTML.trim().replace(/^(?:<br\s*\/?>|\s)+|(?:<br\s*\/?>|\s)+$/gi, '');
              if (qText && cleanedHtml) {
                faqItems.push({ question: qText, answerHtml: cleanedHtml });
              }
            }
          }
        });
      } else {
        // Fallback for flat structure without .faq-item
        var headings = faqContainer.querySelectorAll('h5.heading-font, h5');
        if (headings.length === 0) {
          // Look for any elements with 'Q:'
          var candidates = faqContainer.querySelectorAll('p, div, strong');
          var matched = [];
          candidates.forEach(function (c) {
            if ((c.textContent || '').trim().indexOf('Q:') === 0 && !c.querySelector('p, div')) {
              matched.push(c);
            }
          });
          headings = matched;
        }

        headings.forEach(function (h) {
          var questionText = (h.textContent || '').trim();
          if (!questionText) return;

          var contentNodes = [];
          var curr = h.nextSibling;
          while (curr) {
            if (curr.nodeType === 1 && (curr.matches('h5, h4, h6') || curr.querySelector('h5, h4, h6'))) break;
            if (curr.nodeType === 1 && curr.matches('hr')) break;
            contentNodes.push(curr);
            curr = curr.nextSibling;
          }

          var answerDiv = document.createElement('div');
          contentNodes.forEach(function (node) { answerDiv.appendChild(node.cloneNode(true)); });
          var html = answerDiv.innerHTML.trim().replace(/^(?:<br\s*\/?>|\s)+|(?:<br\s*\/?>|\s)+$/gi, '');
          if (html) {
            faqItems.push({ question: questionText, answerHtml: html });
          }
        });
      }

      // If we found questions, replace faqContainer innerHTML with uniform details accordions
      if (faqItems.length > 0) {
        var newFaqHtml = '';
        faqItems.forEach(function (item) {
          newFaqHtml += '<details>' +
            '<summary class="font-caption-1">' + item.question + '</summary>' +
            '<div class="faq-body font-body rte">' + item.answerHtml + '</div>' +
          '</details>';
        });
        faqContainer.innerHTML = newFaqHtml;
      }
    });

    // Mutually Exclusive Accordions Controller (Animated smooth slideUp / slideDown + only 1 open at a time within its own group)
    var accordionGroups = root.querySelectorAll('[data-accordion-group]');
    accordionGroups.forEach(function (group) {
      var allDetails = group.querySelectorAll('details');

      function closeDetail(detail) {
        var content = detail.querySelector('.faq-body') || detail.querySelector('p');
        if (!content || !detail.hasAttribute('open')) {
          detail.removeAttribute('open');
          return;
        }
        var startHeight = content.offsetHeight;
        content.style.height = startHeight + 'px';
        content.style.overflow = 'hidden';
        content.style.transition = 'height 0.28s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.22s ease';

        // Force reflow
        content.offsetHeight;

        content.style.height = '0px';
        content.style.opacity = '0';

        setTimeout(function () {
          detail.removeAttribute('open');
          content.style.height = '';
          content.style.opacity = '';
          content.style.overflow = '';
          content.style.transition = '';
        }, 280);
      }

      function openDetail(detail) {
        detail.setAttribute('open', '');
        var content = detail.querySelector('.faq-body') || detail.querySelector('p');
        if (!content) return;

        var fullHeight = content.scrollHeight;
        content.style.height = '0px';
        content.style.opacity = '0';
        content.style.overflow = 'hidden';
        content.style.transition = 'height 0.28s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.25s ease';

        // Force reflow
        content.offsetHeight;

        content.style.height = fullHeight + 'px';
        content.style.opacity = '1';

        setTimeout(function () {
          content.style.height = '';
          content.style.opacity = '';
          content.style.overflow = '';
          content.style.transition = '';
        }, 280);
      }

      allDetails.forEach(function (detail) {
        var summary = detail.querySelector('summary');
        if (!summary) return;

        summary.addEventListener('click', function (e) {
          e.preventDefault();

          var isOpen = detail.hasAttribute('open');

          if (isOpen) {
            closeDetail(detail);
          } else {
            // Close all sibling details smoothly
            allDetails.forEach(function (other) {
              if (other !== detail && other.hasAttribute('open')) {
                closeDetail(other);
              }
            });
            openDetail(detail);
          }
        });
      });
    });

    // Quantity Selector logic
    var qty = 1;
    var qtyDisplay = root.querySelector('.sdusacro-qval');
    var qtyInput = root.querySelector('.sdusacro-qty-input');
    var qtyButtons = root.querySelectorAll('.sdusacro-qty button');

    qtyButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var delta = parseInt(btn.getAttribute('data-q'), 10) || 0;
        qty = Math.min(10, Math.max(1, qty + delta));
        if (qtyDisplay) qtyDisplay.textContent = qty;
        if (qtyInput) qtyInput.value = qty;
      });
    });

    // Mobile Sticky Add-to-Cart Bar
    var buybox = root.querySelector('.sdusacro-buybox');
    var mainAddBtn = root.querySelector('#product-form-add-to-cart');
    var titleEl = root.querySelector('.sdusacro-h1');
    var priceEl = root.querySelector('.sdusacro-price');

    if (buybox && mainAddBtn && titleEl && priceEl) {
      var stickyBar = document.createElement('div');
      stickyBar.className = 'sdusacro-stickybar';
      stickyBar.setAttribute('aria-hidden', 'true');

      var isAvailable = !mainAddBtn.disabled;
      var btnSpan = mainAddBtn.querySelector('span');
      var mainBtnText = btnSpan ? btnSpan.textContent.trim() : 'Add to cart';
      var imgSrc = hero || (gallery.length ? gallery[0] : '');

      var priceCents = priceEl.getAttribute('data-cents') || '';

      stickyBar.innerHTML = '<div class="sb-inner">' +
        (imgSrc ? '<img class="sb-img" src="' + imgSrc + '" alt="" width="42" height="42" loading="lazy">' : '') +
        '<div class="sb-info">' +
          '<span class="sb-title font-caption-1">' + (titleEl.textContent || '').trim() + '</span>' +
          '<span class="sb-price font-heading-6"' + (priceCents ? ' data-cents="' + priceCents + '"' : '') + '>' + (priceEl.innerHTML || '').trim() + '</span>' +
        '</div>' +
        '<button type="button" class="sb-add font-caption-1"' + (isAvailable ? '' : ' disabled') + '>' +
          (isAvailable ? mainBtnText : 'Sold out') +
        '</button>' +
      '</div>';

      root.appendChild(stickyBar);

      // Trigger currency refresh if CurrencyEngine is active
      if (window.CurrencyEngine && typeof window.CurrencyEngine.refresh === 'function') {
        window.CurrencyEngine.refresh();
      }

      var stickyAddBtn = stickyBar.querySelector('.sb-add');
      if (stickyAddBtn) {
        stickyAddBtn.addEventListener('click', function () {
          if (!mainAddBtn.disabled) {
            mainAddBtn.click();
          }
        });
      }

      var ticking = false;
      var updateStickyBar = function () {
        var rect = buybox.getBoundingClientRect();
        var shouldShow = rect.bottom < 0;
        stickyBar.classList.toggle('show', shouldShow);
        stickyBar.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
        ticking = false;
      };

      window.addEventListener('scroll', function () {
        if (!ticking) {
          window.requestAnimationFrame(updateStickyBar);
          ticking = true;
        }
      }, { passive: true });

      window.addEventListener('resize', updateStickyBar);
      updateStickyBar();
    }
    // AJAX Add to Cart Handler (prevent redirect and open right sidebar cart drawer)
    function handleAjaxAddToCart(form, submitBtn, getExtraItem) {
      if (!form) return;
      form.addEventListener('submit', function (e) {
        e.preventDefault();

        var btn = submitBtn || form.querySelector('[type="submit"]') || form.querySelector('button');
        if (btn && btn.classList.contains('is-loading')) return;

        if (btn) {
          btn.classList.add('is-loading');
          btn.setAttribute('aria-disabled', 'true');
        }

        var cartItems = document.querySelector('cart-items');
        var formVariantId = form.querySelector('input[name="id"]') ? form.querySelector('input[name="id"]').value : null;
        var formQty = form.querySelector('input[name="quantity"]') ? (parseInt(form.querySelector('input[name="quantity"]').value, 10) || 1) : 1;

        var extraItemPromise = (typeof getExtraItem === 'function')
          ? getExtraItem()
          : Promise.resolve(null);

        extraItemPromise
          .then(function (extraItem) {
            var sections = [];
            var sections_url = window.location.pathname;

            if (cartItems && typeof cartItems.getSectionsToRender === 'function') {
              sections = Array.from(
                new Set(
                  cartItems.getSectionsToRender()
                    .filter(function (item) { return Boolean(document.querySelector('#' + item.id)); })
                    .map(function (section) { return section.section; })
                )
              ).filter(Boolean).slice(0, 5);
            }

            var addUrl = (window.routes && window.routes.cart_add_url)
              || (window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js');

            var requestBody;
            var requestHeaders = {
              'X-Requested-With': 'XMLHttpRequest',
              'Accept': 'application/json'
            };

            // If main product also needs to be added, use multi-item JSON format
            if (extraItem && extraItem.id) {
              var payload = {
                items: [
                  { id: extraItem.id, quantity: extraItem.quantity || 1 },
                  { id: formVariantId, quantity: formQty }
                ]
              };
              if (sections.length > 0) {
                payload.sections = sections.join(',');
                payload.sections_url = sections_url;
              }
              requestHeaders['Content-Type'] = 'application/json';
              requestBody = JSON.stringify(payload);
            } else {
              // Standard single-item form submission
              var formData = new FormData(form);
              if (sections.length > 0) {
                formData.append('sections', sections.join(','));
                formData.append('sections_url', sections_url);
              }
              requestBody = formData;
            }

            var cartItemsCountOld = document.querySelector('cart-items')
              ? document.querySelector('cart-items').querySelectorAll('.minicart-prd').length
              : 0;

            return fetch(addUrl, {
              method: 'POST',
              headers: requestHeaders,
              body: requestBody
            })
              .then(function (res) { return res.json(); })
              .then(function (response) {
                return { response: response, cartItemsCountOld: cartItemsCountOld };
              });
          })
          .then(function (data) {
            var response = data.response;
            var cartItemsCountOld = data.cartItemsCountOld;

            if (response.status && response.message) {
              console.error('Add to cart error:', response.description || response.message);
              alert(response.description || response.message);
              return;
            }

            // Update cart drawer contents if theme cartItems is present
            if (cartItems && typeof cartItems.renderContents === 'function' && response.sections) {
              cartItems.renderContents(response);
              if (typeof cartItems.toggleEmptyClass === 'function') {
                cartItems.toggleEmptyClass(response);
              }
              if (typeof cartItems.setCartJs === 'function') {
                cartItems.setCartJs();
              }
              if (typeof cartItems.setParsedState === 'function') {
                cartItems.setParsedState(response);
              }

              var shippingCalculator = document.querySelector('shipping-calculator') || document.querySelector('shipping-calculator-cart');
              if (shippingCalculator && typeof shippingCalculator.setUpdateStatus === 'function') {
                shippingCalculator.setUpdateStatus('true');
              }
            } else if (cartItems && typeof cartItems.renderAndOpenMiniCartPopup === 'function') {
              cartItems.renderAndOpenMiniCartPopup();
            }

            // Dispatch global cart event for any third-party discount or cart apps
            try {
              document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { response: response } }));
              document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            } catch (evErr) {}

            // Open right sidebar drawer
            var miniCartPopup = document.querySelector('mini-cart-popup');
            if (cartItems && typeof cartItems.setStatus === 'function') {
              var cartItemsCountNew = document.querySelector('cart-items')
                ? document.querySelector('cart-items').querySelectorAll('.minicart-prd').length
                : 0;
              var isCartOpened = function () {
                var el = document.querySelector('.dropdn-modal-minicart');
                return el && el.classList.contains('is-opened');
              };

              var addedCount = response.items ? response.items.length : 1;
              if (cartItemsCountNew > cartItemsCountOld) {
                cartItems.setStatus('new', null, addedCount, !isCartOpened());
              } else {
                cartItems.setStatus('new', null, addedCount, true);
              }
            } else if (miniCartPopup && typeof miniCartPopup.open === 'function') {
              miniCartPopup.open();
            } else {
              // Fallback trigger click on header minicart icon
              var cartLink = document.querySelector('.js-minicart-link') || document.querySelector('[data-selector="#dropdnMinicartPopup"]');
              if (cartLink) cartLink.click();
            }

            // Trigger Frequently Bought Together side drawer if available
            var handle = response.handle || (response.items && response.items[0] && response.items[0].handle);
            var fbtCartContainer = document.querySelector('[data-render="fbt_cart"]');
            if (handle && fbtCartContainer && miniCartPopup) {
              var fbtUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/') +
                'products/' + handle + '?section_id=frequently-bought-together-view-cart';

              if (document.body.classList.contains('fbt-app') && window.routes && window.routes.product_recommendations_url) {
                var prodId = response.product_id || (response.items && response.items[0] && response.items[0].id);
                fbtUrl = window.routes.product_recommendations_url + '?section_id=frequently-bought-together-view-cart&product_id=' + prodId + '&limit=' + (document.body.dataset.fbtLimit || 4);
              }

              fetch(fbtUrl)
                .then(function (res) { return res.text(); })
                .then(function (fbtHtml) {
                  var doc = new DOMParser().parseFromString(fbtHtml, 'text/html');
                  if (doc.querySelector('.minicart-prd')) {
                    var secInner = doc.querySelector('.shopify-section');
                    fbtCartContainer.innerHTML = secInner ? secInner.innerHTML : doc.body.innerHTML;
                    if (typeof miniCartPopup.openChild === 'function') {
                      miniCartPopup.openChild();
                    }
                  } else {
                    if (typeof miniCartPopup.closeChild === 'function') {
                      miniCartPopup.closeChild();
                    }
                  }
                })
                .catch(function (err) {
                  console.error('FBT Cart fetch error:', err);
                });
            }
          })
          .catch(function (err) {
            console.error('AJAX add to cart failed:', err);
          })
          .finally(function () {
            if (btn) {
              btn.classList.remove('is-loading');
              btn.removeAttribute('aria-disabled');
            }
          });
      });
    }

    // Check if main product variant is currently in the cart
    function isMainProductInCart(mainVariantId) {
      var cartUrl = (window.routes && window.routes.cart_url)
        || (window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root + 'cart.js' : '/cart.js');
      if (!cartUrl.endsWith('.js')) {
        cartUrl = cartUrl.replace(/\/+$/, '') + '.js';
      }

      return fetch(cartUrl, {
        headers: { 'Accept': 'application/json' }
      })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          if (!cart || !Array.isArray(cart.items)) return false;
          return cart.items.some(function (item) {
            return String(item.id) === String(mainVariantId) || String(item.variant_id) === String(mainVariantId);
          });
        })
        .catch(function () {
          return false;
        });
    }

    // Attach AJAX Add-to-Cart to the main buybox form
    var mainBuyboxForm = root.querySelector('.sdusacro-buybox-form');
    if (mainBuyboxForm) {
      handleAjaxAddToCart(mainBuyboxForm, mainAddBtn);
    }

    // Attach AJAX Add-to-Cart to Add-ons and Recommended Products forms
    var addonForms = root.querySelectorAll('.sdusacro-addon form');
    addonForms.forEach(function (form) {
      var btn = form.querySelector('.sdusacro-addon-btn');
      var isRecommended = Boolean(form.closest('.sdusacro-rail .sdusacro-addons, .sdusacro-addons'));

      handleAjaxAddToCart(form, btn, function () {
        if (!isRecommended || !mainBuyboxForm) return Promise.resolve(null);

        var mainIdInput = mainBuyboxForm.querySelector('input[name="id"]');
        var mainQtyInput = mainBuyboxForm.querySelector('input[name="quantity"]') || mainBuyboxForm.querySelector('.sdusacro-qty-input');
        var mainVariantId = mainIdInput ? mainIdInput.value : null;
        var mainQty = mainQtyInput ? (parseInt(mainQtyInput.value, 10) || 1) : 1;

        if (!mainVariantId) return Promise.resolve(null);

        return isMainProductInCart(mainVariantId).then(function (alreadyInCart) {
          if (!alreadyInCart) {
            return {
              id: mainVariantId,
              quantity: mainQty
            };
          }
          return null;
        });
      });
    });

    // Product Reviews App Block Loader Handler
    var appBlocks = root.querySelectorAll('.sdusacro-app-block.is-loading');
    appBlocks.forEach(function (appBlock) {
      var inner = appBlock.querySelector('.sdusacro-app-inner') || appBlock;
      var observer = null;
      var checkInterval = null;
      var timeoutId = null;

      function isLoaded() {
        if (!inner) return false;
        if (inner.querySelectorAll('iframe').length > 0) return true;
        var all = inner.querySelectorAll('*');
        for (var i = 0; i < all.length; i++) {
          var el = all[i];
          if (el.offsetHeight > 30 || (el.innerText && el.innerText.trim().length > 10)) {
            return true;
          }
        }
        return false;
      }

      function done() {
        appBlock.classList.remove('is-loading');
        if (observer) observer.disconnect();
        if (checkInterval) clearInterval(checkInterval);
        if (timeoutId) clearTimeout(timeoutId);
      }

      if (isLoaded()) {
        done();
        return;
      }

      if (window.MutationObserver) {
        observer = new MutationObserver(function () {
          if (isLoaded()) done();
        });
        observer.observe(inner, {
          childList: true,
          subtree: true,
          characterData: true,
          attributes: true
        });
      }

      checkInterval = setInterval(function () {
        if (isLoaded()) done();
      }, 250);

      timeoutId = setTimeout(done, 5000);
    });

    // Reviews Link Smooth Scroll Handler
    var reviewsLink = root.querySelector('.sdusacro-rating');
    if (reviewsLink) {
      reviewsLink.addEventListener('click', function (e) {
        var targetEl = document.getElementById('klaviyo-reviews-list') ||
                       document.querySelector('.sdusacro-app-block') ||
                       document.querySelector('.klaviyo-reviews-all') ||
                       document.querySelector('#shopify-block-klaviyo_reviews');

        if (targetEl) {
          e.preventDefault();
          targetEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    }

    // Comparison Table Truncation & Read More
    var comptables = root.querySelectorAll('.sdusacro-comptable');
    comptables.forEach(function (container) {
      var table = container.querySelector('table');
      if (!table || container.dataset.truncateInitialized === '1') return;

      var allRows = Array.from(table.querySelectorAll('tr'));

      // Check if price rows need to be hidden
      if (container.classList.contains('hide-prices')) {
        allRows.forEach(function (row) {
          var firstCell = row.querySelector('th, td');
          var text = firstCell ? firstCell.textContent.trim().toLowerCase() : '';
          var hasPriceData = row.querySelector('.sdusacro-table-price, [data-cents]') !== null;
          if (text === 'price' || text === 'store price' || text.indexOf('price') !== -1 || hasPriceData) {
            row.style.setProperty('display', 'none', 'important');
            row.classList.add('sdusacro-price-hidden-row');
          }
        });
      }

      var visibleRows = allRows.filter(function (row) {
        return !row.classList.contains('sdusacro-price-hidden-row') && !row.classList.contains('sdusacro-comptable-toggle-row') && row.style.display !== 'none';
      });

      var maxRows = 14; // 1 header row + 10 data rows
      if (visibleRows.length > maxRows) {
        container.dataset.truncateInitialized = '1';
        var hiddenRows = visibleRows.slice(maxRows);
        hiddenRows.forEach(function (row) {
          row.classList.add('is-truncated-row');
          row.classList.remove('is-shown');
        });

        var firstRow = visibleRows[0];
        var colCount = (firstRow && firstRow.children.length) || 3;
        var toggleRow = document.createElement('tr');
        toggleRow.className = 'sdusacro-comptable-toggle-row';
        toggleRow.innerHTML = '<td colspan="' + colCount + '">' +
          '<button type="button" class="sdusacro-comptable-toggle-btn" aria-expanded="false">' +
          '<span class="toggle-text">Read more (' + hiddenRows.length + ' more features)</span>' +
          '<svg viewBox="0 0 24 24"><path d="M6 9l6 6 6-6"></path></svg>' +
          '</button>' +
          '</td>';

        var tbody = table.querySelector('tbody') || table;
        tbody.appendChild(toggleRow);

        var toggleBtn = toggleRow.querySelector('.sdusacro-comptable-toggle-btn');
        var toggleText = toggleRow.querySelector('.toggle-text');
        var isExpanded = false;

        toggleRow.addEventListener('click', function (e) {
          e.preventDefault();
          isExpanded = !isExpanded;
          container.classList.toggle('is-expanded', isExpanded);
          toggleBtn.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');

          if (isExpanded) {
            hiddenRows.forEach(function (row, idx) {
              row.classList.add('is-shown');
              row.style.animationDelay = (idx * 0.02) + 's';
            });
            toggleText.textContent = 'Show less';
          } else {
            hiddenRows.forEach(function (row) {
              row.classList.remove('is-shown');
            });
            toggleText.textContent = 'Read more (' + hiddenRows.length + ' more features)';

            var headerOffset = container.getBoundingClientRect().top + window.pageYOffset - 100;
            if (window.pageYOffset > headerOffset) {
              window.scrollTo({ top: headerOffset, behavior: 'smooth' });
            }
          }
        });
      }
    });
  }

  function initAll() {
    document.querySelectorAll('.sdusacro-wrapper').forEach(initSection);
  }

  if (document.readyState !== 'loading') {
    initAll();
  } else {
    document.addEventListener('DOMContentLoaded', initAll);
  }

  // Support Shopify Theme Customizer events
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target) {
      var wrapper = e.target.querySelector('.sdusacro-wrapper') || (e.target.classList.contains('sdusacro-wrapper') ? e.target : null);
      if (wrapper) {
        wrapper.dataset.init = '';
        initSection(wrapper);
      }
    }
  });
})();

